/*
 * LL Warenkorb · Wäscheleine (eigener Warenkorb, Little & Loved, 2026-10-17).
 *
 * Eigene Schublade (ersetzt seit 2026-10-17 die frühere Bundle-App). Was sie tut:
 *   - zeigt die Teile, den Namens-Aufpreis klein unter dem Textil, die
 *     Gratis-Socke als Geschenk (mit Größenwahl) und Shopifys echte Summe
 *   - hängt jedes Kleidungsstück in seiner Farbe an die Leine; die Stufen
 *     (Staffel aus window.LLKorb) zählen NUR Kleidungsstücke
 *   - legt die Gratis-Socke genau 1× dazu, solange ein Kleidungsstück drin ist
 *   - schlägt passende Teile in der Größe aus dem Warenkorb vor
 * Was sie NICHT tut: Preise rechnen. Rabatte macht Shopify an der Kasse,
 * angezeigt wird cart.js. Den Namens-Aufpreis hält weiter ll-warenkorb.js
 * (App-Embed) am Textil fest.
 */
(function () {
  if (window.__llKorb) return;
  window.__llKorb = true;

  var C = window.LLKorb || {};
  /* Versandgrenze in Euro für alle Texte, aus dem Snippet (Marian 2026-11-03: 49 €). */
  var VERSAND_AB = C.versand && C.versand.gratisAb ? Math.round(C.versand.gratisAb / 100) : 49;
  var root = C.root || '/';
  /*
    Marian 2026-10-27: Halloween-Sale als zuschaltbarer Modus (window.LLKorb.modus = 'halloween' im Snippet).
    Ohne den Schalter sieht und rechnet alles wie bisher. Im Modus: fünf Klammern, Staffel 5/15/25/30, kein
    Gratis-Teil, Nachtblau mit Kürbis-Orange, Gespenster als leere Plätze. Die Prozente müssen den Shopify-
    Rabatten entsprechen (scripts/_ll-staffel-rabatte.ts halloween-*); gerechnet wird weiterhin nur von Shopify.
  */
  /*
    Marian 2026-10-31: Aktion SPOOKY25 (window.LLKorb.modus = 'spooky'). Keine Staffel, kein Gratis-Teil, oben ein
    Feld in Nachtfarben mit Kürbis im Hintergrund, „Heute 25 % auf alles“ und dem Code, den die Kundin an der Kasse
    selbst eingibt. Das Feld ist NICHT höher als das bisherige Leinenfeld (Handy 118 px), sonst sieht man die Teile
    nicht. Ab C.spooky.bis gilt von selbst wieder der Standard-Korb (Shopify-Staffel ist für denselben Zeitpunkt geplant).
  */
  var SPOOKY = C.modus === 'spooky' && !!C.spooky && !(Date.now() >= Date.parse(C.spooky.bis));
  if (SPOOKY) {
    C.staffel = [];
    C.viertes = null;
  }
  /* Optik von Halloween (Orange, Gespenster, enge Handy-Fassung) teilen sich beide Modi; die Staffel-Logik nur Halloween. */
  var HALLOWEEN = C.modus === 'halloween';
  var GRUSEL = HALLOWEEN || SPOOKY;
  /* Herbst-Look „Laub“ (Marian 2026-11-01): nur Optik, Staffel wie im Standard. */
  var LAUB = !GRUSEL && C.look === 'laub';
  /* Look „klar“ (Marian 2026-11-03, Vorbild Snocks): weiß und ruhig, statt der Leine eine schmale Sparleiste, Fuß mit
     Zwischensumme, Ersparnis, Versand, Lieferung und „Sicher zur Kasse“. Nur Optik, Staffel wie im Standard. */
  var KLAR = !GRUSEL && C.look === 'klar';
  /* Herbst-Leine im klaren Look (Marian 2026-11-04: „die Leine zeigt die aktuelle Staffel, damit man kapiert, wer mehr kauft,
     bekommt einen besseren Preis“): Kopf, Nadel und Fuß bleiben „klar“, statt nichts hängt oben randlos die Laub-Leine, unten
     wieder Vorschläge. An mit leine: 'herbst' im Snippet; zum Ansehen vorab ?llk-vorschau=herbst (gilt für die Sitzung). */
  var VORSCHAU = (function () {
    try { var m = location.search.match(/[?&]llk-vorschau=([a-z]+)/); if (m) sessionStorage.setItem('llk-vorschau', m[1] === 'aus' ? '' : m[1]); return sessionStorage.getItem('llk-vorschau'); } catch (x) { return null; }
  })();
  var HERBST = KLAR && (C.leine === 'herbst' || VORSCHAU === 'herbst');
  if (HALLOWEEN) {
    C.staffel = (C.halloween && C.halloween.staffel) || [[2, 5], [3, 15], [4, 25], [5, 30]];
    C.viertes = null;
  }
  var STUFE_MAX = (C.staffel || []).reduce(function (m, s) { return Math.max(m, s[1]); }, 0);
  var TEILE_MAX = (C.staffel || []).reduce(function (m, s) { return Math.max(m, s[0]); }, 0);
  var SEIL = SPOOKY ? '#d98a4a' : HALLOWEEN ? '#c26b25' : (LAUB || HERBST) ? '#9a6a3c' : '#b39c80';
  /* Handy-Fassung des Halloween-Modus (eng); am Desktop bleibt die große Leine. Bei jedem Zeichnen neu gefragt (Drehen, Fenster). */
  function klein() { return (GRUSEL || LAUB || HERBST) && !!(window.matchMedia && window.matchMedia('(max-width: 767px)').matches); }
  var MARKE = { 'X-LL-Korb': '1' };
  var korb = null;
  var offen = false;
  var laeuft = false;
  var wahl = {};
  var empfehlungen = { fuer: null, liste: [] };
  var el = {};
  var gruppen = [];

  /* ---------- kleine Helfer ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function geld(cent) {
    var w = (korb && korb.currency) || 'EUR';
    try { return new Intl.NumberFormat('de-DE', { style: 'currency', currency: w }).format(cent / 100); }
    catch (e) { return (cent / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function opt(item, name) {
    var o = (item.options_with_values || []).filter(function (x) { return x.name === name; })[0];
    return o ? o.value : '';
  }
  function bildUrl(url, breite) {
    if (!url) return '';
    if (typeof url === 'object') url = url.url || url.src || '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + breite;
  }
  function anfrage(pfad, daten) {
    var o = { headers: Object.assign({ Accept: 'application/json' }, MARKE) };
    if (daten) { o.method = 'POST'; o.headers['Content-Type'] = 'application/json'; o.body = JSON.stringify(daten); }
    return fetch(root + pfad, o).then(function (r) {
      if (!r.ok) return r.json().catch(function () { return {}; }).then(function (j) { throw new Error(j.description || j.message || 'Fehler'); });
      return r.json();
    });
  }
  /*
    Alte Warenkorb-Attribute der früheren Bundle-App (moonbundle_*) still entfernen, damit sie nicht mehr an unseren Bestellungen
    stehen (Marian 2026-11-04: „alles rausnehmen, was denen gehört“). Shopify hebt einen Warenkorb samt Attributen auf, solange die Kundin
    wiederkommt; ein leerer Wert löscht das Attribut. Einmal je Sitzung, unabhängig davon, ob die Tasche geöffnet wird.
  */
  (function altlastWeg() {
    try { if (sessionStorage.getItem('llk-alt-attr')) return; sessionStorage.setItem('llk-alt-attr', '1'); } catch (x) { /* ohne Speicher trotzdem prüfen */ }
    anfrage('cart.js').then(function (c) {
      var weg = {};
      Object.keys((c && c.attributes) || {}).forEach(function (k) { if (/^moon/i.test(k)) weg[k] = ''; });
      if (Object.keys(weg).length) return anfrage('cart/update.js', { attributes: weg });
    }).catch(function () {});
  })();
  var letzteSlots = [];
  function istKleidung(i) { return (C.rabattTypen || []).indexOf(i.product_type) >= 0; }
  function istSocke(i) { return C.socke && i.variant_id === C.socke.variantId; }
  function istAufpreis(i) { return i.handle === C.aufpreisHandle || (C.aufpreisId && i.variant_id === C.aufpreisId); }
  function stufe(n) {
    var p = 0;
    (C.staffel || []).forEach(function (s) { if (n >= s[0]) p = s[1]; });
    return p;
  }
  /* Was Shopify auf dieser Zeile über „Jedes 4. Teil gratis“ abgezogen hat (Cent). Nichts wird geschätzt. */
  function gratisCent(i) {
    var s = 0;
    (i.line_level_discount_allocations || []).forEach(function (a) {
      var t = a.discount_application && a.discount_application.title;
      if (C.viertes && t === C.viertes.titel) s += a.amount;
    });
    return s;
  }
  /* Was ein eingegebener Code (Gutschein, Karte) am ganzen Korb abzieht (Cent): Bestellrabatte und Zeilen-Zuteilungen vom Typ discount_code. */
  function gutscheinCent(cart) {
    var s = 0;
    (cart.cart_level_discount_applications || []).forEach(function (a) { if (a.type === 'discount_code') s += a.total_allocated_amount || 0; });
    (cart.items || []).forEach(function (i) {
      (i.line_level_discount_allocations || []).forEach(function (a) {
        var d = a.discount_application;
        if (d && d.type === 'discount_code') s += a.amount || 0;
      });
    });
    return s;
  }
  /* Satz unter der Leine: zählt bis zum nächsten freien Teil. */
  function leinenText(n) {
    if (SPOOKY) return '';
    if (HALLOWEEN) {
      if (n === 0) return 'Ab 2 Teilen wird’s gespenstisch günstig.';
      if (n >= TEILE_MAX) return '−' + STUFE_MAX + ' % auf alles. Gruselig gut.';
      var naechste = stufe(n + 1);
      if (n === 1) return 'Noch 1 Teil, dann −' + naechste + ' % auf alles.';
      if (n + 1 === TEILE_MAX) {
        /* Bei 4 Teilen ein Satz für Rabatt und zweites Paar Socken statt zwei Zeilen untereinander (eine Zeile am Handy). */
        var socken = C.socke && C.socke.zweitesAb === n + 1 ? ' und ein zweites Paar Socken' : '';
        return socken ? 'Noch 1 Teil, dann −' + naechste + ' %' + socken + '.' : 'Noch 1 Teil, dann −' + naechste + ' %. Mehr geht nicht.';
      }
      return 'Noch 1 Teil, dann −' + naechste + ' %.';
    }
    if (!C.viertes) {
      /* Staffel ohne Gratis-Teil (Marian 2026-11-03): 5 / 10 / 20 %, die höchste Stufe heißt Familienpreis. */
      if (!(C.staffel || []).length) return '';
      if (n === 0) return 'Ab ' + TEILE_MAX + ' Teilen −' + STUFE_MAX + ' % auf alles.';
      if (n >= TEILE_MAX) return '−' + STUFE_MAX + ' % auf alles. Familienpreis.';
      return 'Noch 1 Teil, dann −' + stufe(n + 1) + ' % auf alles.';
    }
    var ab = C.viertes.ab;
    if (n === 0) return 'Jedes vierte Teil ist gratis.';
    if (n % ab === 0) return n === ab ? 'Dein viertes Teil ist gratis.' : 'Dein ' + n + '. Teil ist gratis.';
    var rest = ab - (n % ab);
    if (n > ab) return 'Noch ' + rest + (rest === 1 ? ' Teil' : ' Teile') + ' bis zum nächsten Gratis-Teil.';
    return rest === 1 ? 'Nur noch 1 Teil, dann ist das günstigste gratis.' : 'Noch ' + rest + ' Teile, dann ist eins gratis.';
  }

  /* ---------- Formen für Leine und Platzhalter ---------- */
  var FORM = {
    hoodie: ['M15.5 8C15.5 1.8 28.5 1.8 28.5 8L34.5 10.5C37 17 39.5 25 41 32.5L36.2 34 31.8 21V41.5H12.2V21L7.8 34 3 32.5C4.5 25 7 17 9.5 10.5Z', 'M17.5 9C19 13 25 13 26.5 9M3.6 30L8.3 31.6M40.4 30L35.7 31.6M12.2 38.5H31.8M16 29.5H28L29.5 35.5H14.5Z'],
    zip: ['M15.5 8C15.5 1.8 28.5 1.8 28.5 8L34.5 10.5C37 17 39.5 25 41 32.5L36.2 34 31.8 21V41.5H12.2V21L7.8 34 3 32.5C4.5 25 7 17 9.5 10.5Z', 'M17.5 9C19 13 25 13 26.5 9M3.6 30L8.3 31.6M40.4 30L35.7 31.6M12.2 38.5H31.8M22 11.5V41.5'],
    sweat: ['M16 7C18 10.5 26 10.5 28 7L34.5 10C37 17 39.5 25 41 32.5L36.2 34 31.8 21V41.5H12.2V21L7.8 34 3 32.5C4.5 25 7 17 9.5 10Z', 'M3.6 30L8.3 31.6M40.4 30L35.7 31.6M12.2 38.5H31.8'],
    shirt: ['M15 6L6 12 10 19 14 17V38H30V17L34 19 38 12 29 6C28 9 25 11 22 11S16 9 15 6Z', ''],
    shorts: ['M9 9H35L38 35H25L22 19 19 35H6Z', 'M9 13H35M22 9V15'],
    hose: ['M12 5H32L35 41H25L22 17 19 41H9Z', 'M12 9H32M10 37H18M26 37H34'],
    body: ['M15 6L7 11 10 17 14 15V31C14 35 18 37 22 37S30 35 30 31V15L34 17 37 11 29 6C27.7 9 25 10.5 22 10.5S16.3 9 15 6Z', 'M19 36.5H25'],
    /* Halloween: leerer Platz als Gespenst (gestrichelt, zwei Augen). */
    gespenst: ['M10 40V17C10 9.5 15.5 4 22 4S34 9.5 34 17V40L30 35.5 26 40 22 35.5 18 40 14 35.5Z', '']
  };
  function formVon(i) {
    var t = ((i.product_type || '') + ' ' + (i.product_title || i.title || '')).toLowerCase();
    if (/zip/.test(t)) return 'zip';
    if (/hoodie/.test(t)) return 'hoodie';
    if (/shorts/.test(t)) return 'shorts';
    if (/jogging|hose/.test(t)) return 'hose';
    if (/sweatshirt|pullover/.test(t)) return 'sweat';
    if (/body/.test(t)) return 'body';
    return 'shirt';
  }
  function hellWert(hex) {
    var m = /^#?([0-9a-f]{6})$/i.exec(hex || '');
    if (!m) return 1;
    var n = parseInt(m[1], 16);
    return (0.299 * ((n >> 16) & 255) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255)) / 255;
  }
  function figur(form, farbe, groesse, leer) {
    var f = FORM[form] || FORM.shirt;
    var hex = (C.farben || {})[farbe] || '#FCF2DF';
    /* Auf Nachtblau brauchen dunkle Teile einen helleren Rand, sonst verschwindet ein schwarzer Hoodie. */
    var strich = leer ? (GRUSEL ? '#8d7a99' : '#c9b8a2') : hellWert(hex) < 0.45 ? (GRUSEL ? '#8d7a99' : '#2b2420') : '#9c8468';
    var augen = form === 'gespenst' ? '<circle cx="17.5" cy="17" r="2" fill="' + strich + '"></circle><circle cx="26.5" cy="17" r="2" fill="' + strich + '"></circle>' : '';
    return '<svg width="' + groesse + '" height="' + groesse + '" viewBox="0 0 44 44" aria-hidden="true">' +
      '<path d="' + f[0] + '" fill="' + (leer ? 'none' : hex) + '" stroke="' + strich + '" stroke-width="1.3" stroke-linejoin="round"' + (leer ? ' stroke-dasharray="3 3"' : '') + '></path>' +
      (leer || !f[1] ? '' : '<path d="' + f[1] + '" fill="none" stroke="' + strich + '" stroke-width="1.1" stroke-linejoin="round"></path>') + augen + '</svg>';
  }
  var PFEIL = '<svg width="8" height="8" viewBox="0 0 12 12" aria-hidden="true"><path d="M2 4l4 4 4-4" stroke="#6b5e55" stroke-width="1.5" fill="none"></path></svg>';

  /* ---------- Socke ---------- */
  var SOCKEN = ['1-3 Jahre', '4-6 Jahre', '7-9 Jahre', '10-13 Jahre'];
  function cm(groesse) {
    var m = /(\d+)\D*$/.exec(groesse || '');
    return m ? Number(m[1]) : 999;
  }
  function sockeAuto(kleider) {
    var g = 0;
    kleider.forEach(function (i) { g = Math.max(g, cm(opt(i, 'Größe'))); });
    return g <= 98 ? SOCKEN[0] : g <= 116 ? SOCKEN[1] : g <= 134 ? SOCKEN[2] : SOCKEN[3];
  }

  /* Wie viele Paar Socken gehören zu n Kleidungsstücken: eins ab dem ersten, zwei ab `zweitesAb`. */
  function sockenSoll(n) {
    if (!C.socke || n <= 0) return 0;
    return C.socke.zweitesAb && n >= C.socke.zweitesAb ? 2 : 1;
  }
  /* Hält die Gratis-Socken bei genau der Soll-Zahl an Zeilen (je Paar eine Zeile mit eigener Größe). true = geändert. */
  function sockenAbgleich(cart) {
    if (!C.socke) return Promise.resolve(false);
    var n = cart.items.filter(istKleidung).reduce(function (s, i) { return s + i.quantity; }, 0);
    var socken = cart.items.filter(istSocke);
    var soll = sockenSoll(n);
    var schritte = [];
    socken.forEach(function (s, idx) {
      var menge = idx < soll ? 1 : 0;
      if (s.quantity !== menge) schritte.push(function () { return anfrage('cart/change.js', { id: s.key, quantity: menge }); });
    });
    var vorhanden = socken.filter(function (s) { return s.quantity > 0; }).length;
    if (vorhanden < soll) {
      /* `_ll_paar` hält die Zeilen auseinander, sonst legt Shopify zwei gleiche Paare zusammen. */
      var neue = [];
      for (var p = vorhanden + 1; p <= soll; p++) neue.push({ id: C.socke.variantId, quantity: 1, properties: p === 1 ? { _ll_geschenk: '1' } : { _ll_geschenk: '1', _ll_paar: String(p) } });
      schritte.push(function () { return anfrage('cart/add.js', { items: neue }); });
    }
    if (!schritte.length) return Promise.resolve(false);
    return schritte.reduce(function (k, f) { return k.then(f); }, Promise.resolve()).then(function () { return true; });
  }

  /* ---------- Laden, Melden ---------- */
  /*
   * Nur `cart:refresh`, kein `cart:change`: Prestige erwartet bei cart:change
   * die gerenderten Abschnitte (cart.sections) und wirft sonst. Auf refresh
   * holen sich Zähler und Aufpreis-Abgleich (ll-warenkorb.js) den Stand selbst.
   */
  function melden() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { baseEvent: 'll:korb' } }));
  }
  /* Nur EIN Abgleich gleichzeitig, sonst legen zwei Läufe je eine Socke ein. */
  var ladeLauf = null, ladeNochmal = false, ladeMelden = false;
  function laden(nachAenderung) {
    if (nachAenderung) ladeMelden = true;
    if (ladeLauf) { ladeNochmal = true; return ladeLauf; }
    var melden_ = ladeMelden; ladeMelden = false;
    ladeLauf = ladenEinmal(melden_).then(function (c) {
      ladeLauf = null;
      if (ladeNochmal) { ladeNochmal = false; return laden(false); }
      return c;
    }, function (e) { ladeLauf = null; ladeNochmal = false; throw e; });
    return ladeLauf;
  }
  /*
    Personalisierung im Familienpaket (Marian 2026-11-03): ab C.namenFamilie.ab Kleidungsstücken gehört jede Aufpreis-Zeile auf
    die Variante „Familie“ (5,90 €), darunter auf die Standard-Variante (7,90 €). Erst die neue Zeile dazulegen, dann die alte
    entfernen: so sieht der Aufpreis-Abgleich (ll-warenkorb.js) nie ein Textil ohne Aufpreis und legt keinen doppelt nach.
  */
  function namenAbgleich(cart) {
    var nf = C.namenFamilie;
    if (!nf || !nf.variantId || !C.aufpreisId) return Promise.resolve(false);
    var n = cart.items.filter(istKleidung).reduce(function (s, i) { return s + i.quantity; }, 0);
    var soll = n >= nf.ab ? nf.variantId : C.aufpreisId;
    var falsch = cart.items.filter(function (i) { return istAufpreis(i) && i.variant_id !== soll && i.quantity > 0; });
    if (!falsch.length) return Promise.resolve(false);
    var weg = {};
    falsch.forEach(function (i) { weg[i.key] = 0; });
    return anfrage('cart/add.js', { items: falsch.map(function (i) { return { id: soll, quantity: i.quantity, properties: i.properties || {} }; }) })
      .then(function () { return anfrage('cart/update.js', { updates: weg }); })
      .then(function () { return true; });
  }
  function ladenEinmal(nachAenderung) {
    return anfrage('cart.js').then(function (cart) {
      return sockenAbgleich(cart).then(function (geaendert) {
        return geaendert ? anfrage('cart.js') : cart;
      }).then(function (c) {
        return namenAbgleich(c).then(function (geaendert) { return geaendert ? anfrage('cart.js') : c; });
      }).then(function (c) {
        korb = c;
        if (nachAenderung) melden();
        zeichnen();
        empfehlungenLaden();
        return c;
      });
    });
  }
  function aendern(daten) {
    if (laeuft) return Promise.resolve();
    laeuft = true;
    el.wurzel.setAttribute('data-laedt', '');
    var liste = Array.isArray(daten) ? daten : [daten];
    return liste.reduce(function (k, d) { return k.then(function () { return anfrage('cart/change.js', d); }); }, Promise.resolve())
      .then(function () { return laden(true); })
      .catch(function () { return laden(true); })
      .then(function () { laeuft = false; el.wurzel.removeAttribute('data-laedt'); });
  }
  function dazu(variantId, knopf) {
    if (knopf) knopf.disabled = true;
    el.wurzel.setAttribute('data-laedt', '');
    return anfrage('cart/add.js', { items: [{ id: variantId, quantity: 1 }] })
      .then(function () { return laden(true); })
      .catch(function () { if (knopf) knopf.disabled = false; })
      .then(function () { el.wurzel.removeAttribute('data-laedt'); });
  }

  /* ---------- Empfehlungen ---------- */
  function empfehlungenLaden() {
    if (!korb) return;
    var kleider = korb.items.filter(istKleidung);
    if (!kleider.length) { empfehlungen = { fuer: null, liste: [] }; zeichneVorschlaege(); return; }
    var basis = kleider[kleider.length - 1].product_id;
    if (empfehlungen.fuer === basis) { zeichneVorschlaege(); return; }
    empfehlungen.fuer = basis;
    var url = 'recommendations/products.json?product_id=' + basis + '&limit=10&intent=related';
    anfrage(url).then(function (j) {
      if (empfehlungen.fuer !== basis) return;
      empfehlungen.liste = (j.products || []).filter(function (p) { return (C.rabattTypen || []).indexOf(p.type) >= 0; });
      zeichneVorschlaege();
    }).catch(function () { empfehlungen.liste = []; zeichneVorschlaege(); });
  }
  function karteDaten(p, groesse) {
    var namen = (p.options || []).map(function (o) { return typeof o === 'string' ? o : o && o.name; });
    var gi = namen.indexOf('Größe');
    var fi = namen.indexOf('Farbe');
    var wert = function (v, idx) { return idx < 0 ? '' : v['option' + (idx + 1)]; };
    var verfuegbar = (p.variants || []).filter(function (v) { return v.available; });
    var groessen = [];
    verfuegbar.forEach(function (v) { var g = wert(v, gi); if (g && groessen.indexOf(g) < 0) groessen.push(g); });
    var gew = wahl[p.id] || groesse;
    var v = verfuegbar.filter(function (x) { return wert(x, gi) === gew; })[0];
    if (!v) return null;
    return { p: p, v: v, farbe: wert(v, fi), groesse: gew, groessen: groessen };
  }

  /* ---------- Zeichnen ---------- */
  function lieferText(mitName) {
    var t = mitName ? (C.lieferMitName || [5, 7]) : (C.liefer || [3, 4]);
    var f = function (tage) {
      var d = new Date(); d.setDate(d.getDate() + tage);
      var wt = d.toLocaleDateString('de-DE', { weekday: 'short' }).replace(/\.?$/, '.');
      return wt + ' ' + ('0' + d.getDate()).slice(-2) + '.' + ('0' + (d.getMonth() + 1)).slice(-2) + '.';
    };
    return 'Bei dir ca. ' + f(t[0]) + ' – ' + f(t[1]);
  }

  function zeichnen() {
    if (!el.wurzel || !korb) return;
    var items = korb.items;
    var kleider = items.filter(istKleidung);
    var n = kleider.reduce(function (s, i) { return s + i.quantity; }, 0);
    var aufpreisFuer = {};
    items.filter(istAufpreis).forEach(function (a) {
      var p = (a.properties || {})._parent;
      if (!p) return;
      aufpreisFuer[p] = (aufpreisFuer[p] || 0) + a.original_line_price;
    });

    /* Leine: die ersten vier Kleidungsstücke, Stück für Stück */
    var einheiten = [];
    kleider.slice().reverse().forEach(function (i) { for (var k = 0; k < i.quantity; k++) einheiten.push(i); });
    /* Das Teil, das Shopify frei gibt, hängt an der vierten Klammer, egal wann es in den Korb kam (Marian 2026-10-18). */
    /* Ab dem fünften Teil wird die Leine doppelt so lang: acht Klammern, die vorderen vier drehen sich zur Seite („die sind ja schon im Schrank“). */
    var ab = C.viertes ? C.viertes.ab : 4;
    var dicht = !!C.viertes && n > ab;
    /* Halloween: so viele Klammern wie Stufen (fünf), keine dichte Leine. */
    var plaetzeAnzahl = dicht ? 2 * ab : (HALLOWEEN ? TEILE_MAX : 4);
    if (C.viertes && n >= ab) {
      /* Jedes freie Teil hängt an einer Gratis-Klammer (4., 8.): erst einsammeln, dann einsetzen. */
      var freie = [], rest = [];
      einheiten.forEach(function (e) { (gratisCent(e) > 0 && freie.length < Math.floor(n / ab) ? freie : rest).push(e); });
      einheiten = rest;
      freie.forEach(function (e, fi) { einheiten.splice(Math.min(einheiten.length, (fi + 1) * ab - 1), 0, e); });
    }
    /* Erste Klammer: ohne Gratis-Teil steht dort das Geschenk, das schon ein einzelnes Teil bekommt (Marian 2026-11-03). */
    var stufen = [[1, !C.viertes && !GRUSEL && C.socke ? 'Socken' : '1 Teil']].concat((C.staffel || []).map(function (s) { return [s[0], '−' + s[1] + ' %']; }));
    if (C.viertes) stufen.push([C.viertes.ab, 'gratis']);
    stufen = stufen.slice(0, HALLOWEEN ? TEILE_MAX : 4);
    /* SPOOKY25: vier Klammern ohne Schilder, die Teile hängen einfach der Reihe nach. */
    if (SPOOKY) stufen = [[1, ''], [2, ''], [3, ''], [4, '']];
    if (dicht) { for (var sz = ab + 1; sz <= 2 * ab; sz++) stufen.push([sz, sz === 2 * ab ? 'gratis' : String(sz)]); }
    /* Halloween (Marian 2026-10-27, „mobil ist das overload“): flachere Leine, kleinere Figuren, Platz für die Produkte. */
    var figurGroesse = dicht ? 32 : (klein() ? 34 : 46);
    el.plaetze.style.gridTemplateColumns = 'repeat(' + plaetzeAnzahl + ', minmax(0, 1fr))';
    if (dicht) el.plaetze.parentNode.setAttribute('data-dicht', ''); else el.plaetze.parentNode.removeAttribute('data-dicht');
    /* Merken, was an welcher Klammer hing: wechselt ein Teil den Platz, schwingt es einmal ein. */
    var slotsNeu = stufen.map(function (s, idx) { var e = einheiten[idx]; return n >= s[0] && e ? String(e.key || e.variant_id) : ''; });
    el.plaetze.innerHTML = stufen.map(function (s, idx) {
      var e = einheiten[idx];
      var voll = n >= s[0] && e;
      var gratis = s[1] === 'gratis';
      var neu = voll && letzteSlots.length && letzteSlots[idx] && letzteSlots[idx] !== slotsNeu[idx];
      var schrank = dicht && idx < ab;
      return '<div class="llk__platz"' + (schrank ? ' data-schrank' : '') + '><div class="llk__klammer"></div><div class="llk__teil"' + (voll ? '' : ' data-leer') + (neu ? ' data-neu' : '') + '>' +
        (voll ? figur(formVon(e), opt(e, 'Farbe'), figurGroesse, false) : figur(GRUSEL ? 'gespenst' : 'hoodie', '', figurGroesse, true)) +
        '</div><div class="llk__schild"' + (n >= s[0] ? ' data-an' : '') + (gratis ? ' data-gratis' : '') + '>' + esc(s[1]) + '</div></div>';
    }).join('');
    letzteSlots = slotsNeu;
    /* Marian 2026-10-18: der Hinweis steht genau EIN Teil vor dem zweiten Paar (bei 4 Teilen); liegt das fünfte drin, spricht die neue Socken-Zeile für sich. */
    /* Halloween: steht das zweite Paar Socken schon im Leinen-Satz (4 Teile), kein eigener Hinweis darunter. */
    var sockenImSatz = HALLOWEEN && n + 1 === TEILE_MAX;
    if (el.sockenhinweis) { el.sockenhinweis.textContent = C.socke && C.socke.zweitesAb && n === C.socke.zweitesAb - 1 && !sockenImSatz ? 'Ab dem ' + C.socke.zweitesAb + '. Teil: ein zweites Paar Socken, geschenkt.' : ''; }
    if (el.leinentext) { el.leinentext.textContent = leinenText(n); if ((C.viertes && n > 0 && n % C.viertes.ab === 0) || ((HALLOWEEN || (!C.viertes && !SPOOKY)) && TEILE_MAX && n >= TEILE_MAX)) el.leinentext.setAttribute('data-an', ''); else el.leinentext.removeAttribute('data-an'); }

    /* Liste */
    /*
      Gleiche Variante mit gleichen Eigenschaften = EINE Zeile. Shopify teilt
      Zeilen, sobald ein Mengenrabatt nur auf einzelne Stücke greift; die
      Kundin soll trotzdem „2× Hoodie mit Lillliii“ sehen.
    */
    gruppen = [];
    var jeSignatur = {};
    items.filter(function (i) { return !istSocke(i) && !istAufpreis(i); }).forEach(function (i) {
      var sig = i.variant_id + '|' + JSON.stringify(i.properties || {});
      var g = jeSignatur[sig];
      if (!g) { g = jeSignatur[sig] = { i: i, zeilen: [], quantity: 0, preis: 0, gratis: 0, gratisStk: 0 }; gruppen.push(g); }
      g.zeilen.push(i); g.quantity += i.quantity; g.preis += i.original_line_price;
      var gc = gratisCent(i); g.gratis += gc; if (gc > 0) g.gratisStk += Math.max(1, Math.round(gc / Math.max(1, i.original_price)));
    });
    var zeilen = gruppen.map(function (g, gi) {
      var i = g.i;
      var p = i.properties || {};
      var auf = p._pid ? aufpreisFuer[p._pid] : 0;
      var farbe = opt(i, 'Farbe'), groesse = opt(i, 'Größe');
      var variante = [farbe, groesse].filter(Boolean).join(' · ') || (i.variant_title || '');
      var bild = i.featured_image && i.featured_image.url ? '<img src="' + esc(bildUrl(i.featured_image.url, 160)) + '" alt="" loading="lazy" width="64" height="78">' : figur(formVon(i), farbe, 40, false);
      return '<div class="llk__zeile" data-gruppe="' + gi + '">' +
        '<a class="llk__bild" href="' + esc(i.url) + '" tabindex="-1">' + bild + '</a>' +
        '<div class="llk__info">' +
          '<div class="llk__reihe"><a class="llk__name" href="' + esc(i.url) + '">' + esc(i.product_title) + (g.gratis > 0 ? '<span class="llk__geschenkt">' + (g.gratisStk < g.quantity ? g.gratisStk + '× ' : '') + 'geschenkt</span>' : '') + '</a>' +
            (g.gratis > 0 ? '<span class="llk__preis"><s>' + geld(g.preis) + '</s><span class="llk__null">' + geld(g.preis - g.gratis) + '</span></span>' : '<span class="llk__preis">' + geld(g.preis) + '</span>') + '</div>' +
          (variante ? '<div class="llk__variante">' + esc(variante) + '</div>' : '') +
          (p.Personalisierung ? '<div class="llk__reihe"><span class="llk__mitname">mit <em>' + esc(p.Personalisierung) + '</em>' + (p.Position ? ' · ' + esc(p.Position) : '') + '</span>' + (auf ? '<span class="llk__aufpreis">+ ' + geld(auf) + '</span>' : '') + '</div>' : '') +
          '<div class="llk__aktionen"><div class="llk__menge"><button type="button" data-tun="minus" aria-label="Eins weniger">−</button><span>' + g.quantity + '</span><button type="button" data-tun="plus" aria-label="Eins mehr">+</button></div>' +
          '<button type="button" class="llk__weg" data-tun="weg" aria-label="Aus dem Warenkorb nehmen"><svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true"><path d="M1.5 1.5l7 7M8.5 1.5l-7 7" stroke="currentColor" stroke-width="1.2" fill="none"></path></svg></button></div>' +
        '</div></div>';
    });

    items.filter(istSocke).forEach(function (socke, si) {
      var auto = sockeAuto(kleider);
      var gewaehlt = (socke.properties || {})._sockengroesse || auto;
      var paar = (socke.properties || {})._ll_paar || '';
      zeilen.push('<div class="llk__socke" data-key="' + esc(socke.key) + '"' + (paar ? ' data-paar="' + esc(paar) + '"' : '') + '>' +
        '<div class="llk__bild">' + (socke.featured_image && socke.featured_image.url ? '<img src="' + esc(bildUrl(socke.featured_image.url, 120)) + '" alt="" loading="lazy" width="52" height="64">' : '<svg width="24" height="24" viewBox="0 0 30 30" aria-hidden="true"><path d="M11 3h8v12l5 5a4 4 0 01-6 6l-7-7z" stroke="#a5552a" stroke-width="1.3" fill="none"></path></svg>') + '</div>' +
        '<div class="llk__info"><div class="llk__reihe"><span class="llk__name">L&amp;L Socken' + (si > 0 ? ' · ' + (si + 1) + '. Paar' : '') + '<span class="llk__geschenkt">geschenkt</span></span>' +
        '<span class="llk__preis"><s>' + geld(C.socke.wertCent || 790) + '</s><span class="llk__null">' + geld(0) + '</span></span></div>' +
        '<label class="llk__wahl"><span class="llk-sr">Sockengröße</span><select data-tun="socke" data-auto="' + esc(auto) + '">' +
        SOCKEN.map(function (s) { return '<option' + (s === gewaehlt ? ' selected' : '') + '>' + esc(s) + '</option>'; }).join('') +
        '</select>' + PFEIL + '</label></div></div>');
    });

    el.liste.innerHTML = zeilen.length ? zeilen.join('') : KLAR
      ? '<div class="llk__leer llk__leer--klar"><strong>Deine Tasche ist leer</strong><span>Fangen wir an …</span><a class="llk__entdecken" href="' + root + 'collections/all">Lieblingsteile entdecken</a></div>'
      : '<div class="llk__leer"><strong>Noch ganz leer hier.</strong>Socken schenken wir dir zu jeder Bestellung, den Versand ab ' + VERSAND_AB + ' €.</div>';

    /* Summe und Kasse: Shopifys eigene Zahlen */
    var vorher = korb.original_total_price, jetzt = korb.total_price;
    el.summe.innerHTML = (vorher > jetzt ? '<s>' + geld(vorher) + '</s>' : '') + '<strong>' + geld(jetzt) + '</strong>';
    /*
      Marian 2026-10-23: Aktion und Gutschein getrennt zeigen. Ein eingegebener
      Code (Freundschafts-, Kundenkarte, Gutschein) steht bei Shopify als
      Bestellrabatt in cart_level_discount_applications (type discount_code),
      Staffel und „Jedes 4. Teil gratis“ hängen an den Zeilen. Nichts wird
      geschätzt: Gutschein = Shopifys Code-Beträge, „Du sparst“ = der Rest.
    */
    var gutschein = gutscheinCent(korb);
    var aktion = Math.max(0, vorher - jetzt - gutschein);
    /* Marian 2026-10-23: eine Zeile, eine Schrift: „Du sparst 11,97 € + 15,00 € Gutschein“. */
    var teile = [];
    if (aktion > 0) teile.push(geld(aktion));
    if (gutschein > 0) teile.push(geld(gutschein) + ' Gutschein');
    el.gespart.hidden = teile.length === 0;
    /* Halloween (Marian 2026-10-27): hinter „Summe“ in derselben Schrift, in Klammern und grün, spart eine Zeile. */
    el.gespart.textContent = teile.length ? (GRUSEL ? '(du sparst ' + teile.join(' + ') + ')' : 'Du sparst ' + teile.join(' + ')) : '';
    el.kasseBetrag.textContent = geld(jetzt);
    if (!zurKasse) el.kasse.disabled = korb.item_count === 0;
    var mitName = items.some(function (i) { return (i.properties || {}).Personalisierung; });
    el.liefer.textContent = lieferText(mitName);
    if (KLAR && el.stufen) {
      /* Schmale Sparleiste statt Leine: Socken, dann die Stufen; erreicht = grün, die nächste umrandet. */
      var stf = [[1, 'Socken']].concat((C.staffel || []).map(function (x) { return [x[0], '−' + x[1] + ' %']; }));
      el.stufen.innerHTML = stf.map(function (x) {
        return '<li' + (n >= x[0] ? ' data-an' : '') + (x[0] === n + 1 ? ' data-naechste' : '') + '><b>' + (x[0] === TEILE_MAX ? 'ab ' + x[0] : x[0] + (x[0] === 1 ? ' Teil' : ' Teile')) + '</b><span>' + esc(x[1]) + '</span></li>';
      }).join('');
      el.stufentext.textContent = leinenText(n);
    }
    /*
      Marian 2026-10-31: Versand unter der Grenze 5,90 €, darüber kostenlos (Shopify-Versandraten, Bestellwert nach Rabatt). Grenze seit 2026-11-03 49 €, steht nur noch in C.versand.gratisAb.
      Während SPOOKY25 zieht Shopify den Code erst an der Kasse ab; für die Grenze rechnet der Korb ihn darum schon mit ein,
      angezeigt wird nie ein selbst gerechneter Preis, nur „kostenlos“ oder die Versandkosten.
    */
    var V = C.versand;
    if (V && el.versand) {
      var basis = SPOOKY && gutscheinCent(korb) === 0 ? Math.round(jetzt * (100 - C.spooky.prozent) / 100) : jetzt;
      var fehlt = V.gratisAb - basis;
      var frei = fehlt <= 0 || korb.item_count === 0;
      el.versand.textContent = frei ? 'Versand kostenlos' : 'Versand ' + geld(V.preis);
      if (frei) el.versand.removeAttribute('data-kostet'); else el.versand.setAttribute('data-kostet', '');
      el.versandhinweis.hidden = frei;
      el.versandhinweis.textContent = frei ? '' : SPOOKY ? 'Versand gratis ab ' + (V.gratisAb / 100) + ' € Bestellwert nach Rabatt.' : 'Noch ' + geld(fehlt) + ', dann ist der Versand gratis.';
    }
    /* Look „klar“ (Marian 2026-11-03, wie Snocks): schlichte schwarze Zeilen Zwischensumme, Ersparnis, Versandkosten, Lieferung. */
    if (KLAR && el.zeilen) {
      var kostet = !!(V && korb.item_count > 0 && V.gratisAb - jetzt > 0);
      var z = [['Zwischensumme', geld(vorher)]];
      if (vorher > jetzt) z.push(['Ersparnis', '−' + geld(vorher - jetzt), 'spar']);
      z.push(['Versandkosten', kostet ? geld(V.preis) : 'Kostenlos', kostet ? '' : 'frei']);
      if (vorher > jetzt || kostet) z.push(['Gesamt', geld(jetzt + (kostet ? V.preis : 0)), 'gesamt']);
      el.zeilen.innerHTML = korb.item_count ? z.map(function (r) { return '<div class="llk__fz"' + (r[2] ? ' data-art="' + r[2] + '"' : '') + '><span>' + r[0] + '</span><span>' + r[1] + '</span></div>'; }).join('') +
        '<div class="llk__fz llk__fz--liefer"><span>' + esc(lieferText(mitName).replace(/^Bei dir /, 'Lieferung ')) + '</span></div>' : '';
    }
    zeichneVorschlaege();
  }

  function zeichneVorschlaege() {
    if (!el.band || !korb) return;
    var kleider = korb.items.filter(istKleidung);
    var n = kleider.reduce(function (s, i) { return s + i.quantity; }, 0);
    var imKorb = {};
    korb.items.forEach(function (i) { imKorb[i.product_id] = 1; });
    var groesse = kleider.length ? opt(kleider[kleider.length - 1], 'Größe') : '';
    var typenImKorb = {};
    kleider.forEach(function (i) { typenImKorb[i.product_type] = 1; });
    var karten = empfehlungen.liste
      .filter(function (p) { return !imKorb[p.id]; })
      .sort(function (a, b) { return (typenImKorb[a.type] ? 1 : 0) - (typenImKorb[b.type] ? 1 : 0); })
      .map(function (p) { return karteDaten(p, groesse); })
      .filter(Boolean)
      .slice(0, 8);
    el.vorschlaege.hidden = karten.length === 0;
    var naechste = stufe(n + 1);
    var bonus = '';
    if (C.viertes && n >= 1 && (n + 1) % C.viertes.ab === 0) bonus = 'dann eins gratis';
    else if (n >= 1 && naechste > stufe(n)) bonus = 'dann −' + naechste + ' %';
    /* Halloween: der Bonus steht einmal in der Überschrift, nicht auf jeder Karte (flachere Karten). */
    var bonusImTitel = klein();
    if (el.vtitel) el.vtitel.textContent = (KLAR && !HERBST ? 'Passt dazu' : 'Noch was für die Leine') + (bonusImTitel && bonus ? ' · ' + bonus : '');
    el.band.innerHTML = karten.map(function (k) {
      var bild = k.p.featured_image ? '<img src="' + esc(bildUrl(k.p.featured_image, 120)) + '" alt="" loading="lazy" width="52" height="64">' : figur(formVon({ product_type: k.p.type, title: k.p.title }), k.farbe, 36, false);
      return '<div class="llk__karte" data-produkt="' + k.p.id + '">' +
        '<a class="llk__bild" href="' + esc(root + 'products/' + k.p.handle) + '" tabindex="-1">' + bild + '</a>' +
        '<div class="llk__info"><a class="llk__ktitel" href="' + esc(root + 'products/' + k.p.handle) + '">' + esc(k.p.title) + '</a>' +
        '<div class="llk__kpreis">' + geld(k.v.price) + (k.farbe ? ' · ' + esc(k.farbe) : '') + (bonus && !bonusImTitel ? '<span class="llk__bonus">' + esc(bonus) + '</span>' : '') + '</div>' +
        '<div class="llk__kaktion"><label class="llk__wahl llk__wahl--breit"><span class="llk-sr">Größe</span><select data-tun="groesse">' +
        k.groessen.map(function (g) { return '<option' + (g === k.groesse ? ' selected' : '') + '>' + esc(g) + '</option>'; }).join('') +
        '</select>' + PFEIL + '</label><button type="button" class="llk__dazu" data-tun="dazu" data-variante="' + k.v.id + '">Dazu</button></div></div></div>';
    }).join('');
  }

  /* ---------- Aufbau ---------- */
  /* SPOOKY25-Feld: Nachtfarben, glühender Kürbis im Hintergrund, Text oben links, Leine unten. Feste Höhe in ll-korb.css. */
  function spukFeld() {
    var k = '<svg class="llk__kuerbis" viewBox="0 0 74 62" aria-hidden="true"><defs><radialGradient id="llk-glut" cx="50%" cy="58%" r="50%"><stop offset="0" stop-color="#ffd27a"></stop><stop offset="1" stop-color="#ff8a2a"></stop></radialGradient></defs>' +
      '<path d="M37 12c-2-6 1-10 6-11" stroke="#4d6b3a" stroke-width="3.2" fill="none" stroke-linecap="round"></path><path d="M43 6c6-3 12-1 14 4-5 1-10 0-14-4z" fill="#6f8f4e"></path>' +
      '<ellipse cx="22" cy="36" rx="17" ry="22" fill="#c9581a"></ellipse><ellipse cx="52" cy="36" rx="17" ry="22" fill="#c9581a"></ellipse><ellipse cx="37" cy="36" rx="18" ry="24" fill="#e06a1a"></ellipse>' +
      '<path d="M30 14c-3 7-3 37 0 44M44 14c3 7 3 37 0 44" stroke="#b44e16" stroke-width="1.4" fill="none"></path>' +
      '<path d="M24 30l7-5 2 7zM50 30l-7-5-2 7z" fill="url(#llk-glut)"></path><path d="M34 37l3-4 3 4z" fill="url(#llk-glut)"></path>' +
      '<path d="M22 43c5 6 25 6 30 0-3 1-5 1-7 1l-1 3-3-3h-6l-3 3-1-3c-3 0-6 0-9-1z" fill="url(#llk-glut)"></path></svg>';
    var sterne = '<svg class="llk__sterne" aria-hidden="true"><circle cx="62%" cy="14%" r="1.2"></circle><circle cx="54%" cy="62%" r="0.9"></circle><circle cx="70%" cy="40%" r="0.8"></circle><circle cx="8%" cy="58%" r="0.8"></circle></svg>';
    return '<div class="llk__leine-feld llk__spuk">' + sterne + k +
      '<div class="llk__spuk-text"><div class="llk__heute">Heute <b>' + C.spooky.prozent + ' %</b> auf alles</div>' +
      '<div class="llk__unter">mit Code <span class="llk__code">' + esc(C.spooky.code) + '</span> an der Kasse</div></div>' +
      '<div class="llk__leine"><svg class="llk__seil" viewBox="0 0 360 20" preserveAspectRatio="none" aria-hidden="true"><path d="M10 3 Q180 16 350 3" stroke="' + SEIL + '" stroke-width="1.2" fill="none"></path></svg>' +
      '<div class="llk__plaetze"></div></div><div class="llk__leinentext" hidden></div><div class="llk__sockenhinweis" hidden></div></div>';
  }
  /* Ein paar Blätter hinter der Leine, Ecken und Ränder, nie über den Teilen. */
  function laubDeko() {
    /* Herbst-Leine auf Weiß (Marian 2026-11-04: „ohne Kastenhintergrund“): kleinere, kräftigere Blätter, damit sie als Blätter
       lesbar sind und nicht als Flecken. */
    var aufWeiss = HERBST;
    var blatt = function (x, y, r, sk, farbe, op) {
      if (aufWeiss) { sk = sk * 0.55; op = Math.min(0.9, op + 0.4); }
      return '<path transform="translate(' + x + ' ' + y + ') rotate(' + r + ') scale(' + sk + ')" d="M0-12C3-8 9-9 8-3 12-1 10 4 6 4 7 8 3 9 0 12-3 9-7 8-6 4-10 4-12-1-8-3-9-9-3-8 0-12Z M0 12V18" fill="' + farbe + '" stroke="' + farbe + '" stroke-width=".8" opacity="' + op + '"></path>';
    };
    return '<svg class="llk__laub" viewBox="0 0 342 172" preserveAspectRatio="xMidYMid slice" aria-hidden="true">' +
      blatt(18, 20, -25, 1.1, '#d27a3c', .55) + blatt(326, 26, 30, .9, '#b5502c', .45) + blatt(304, 150, -60, 1.2, '#e0a14a', .35) +
      blatt(30, 150, 40, .8, '#b5502c', .3) + blatt(178, 10, 15, .55, '#d27a3c', .35) + '</svg>';
  }
  function bauen() {
    var w = document.createElement('div');
    w.className = 'llk';
    if (SPOOKY) { w.setAttribute('data-modus', 'halloween'); w.setAttribute('data-aktion', 'spooky'); }
    if (HALLOWEEN) { w.setAttribute('data-modus', 'halloween'); w.setAttribute('data-feld', (C.halloween && C.halloween.feld) || 'hell'); }
    if (LAUB) w.setAttribute('data-look', 'laub');
    if (KLAR) w.setAttribute('data-look', 'klar');
    if (HERBST) w.setAttribute('data-leine', 'laub');
    w.innerHTML =
      '<div class="llk__schleier" data-tun="zu"></div>' +
      '<aside class="llk__korb" role="dialog" aria-modal="true" aria-label="Warenkorb" tabindex="-1">' +
        '<div class="llk__kopf">' + (KLAR ? '<svg class="llk__tasche" viewBox="0 0 20 20" width="18" height="18" aria-hidden="true"><path d="M4 7h12l-1 10H5z M7 7V5.5a3 3 0 016 0V7" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"></path></svg>' : '') +
          '<h2 class="llk__titel">' + (KLAR ? 'Deine Tasche' : 'Warenkorb') + '</h2>' +
          (KLAR ? '<button type="button" class="llk__nadel" data-tun="nadel" aria-pressed="false" aria-label="Tasche anpinnen" title="Tasche anpinnen"><svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true"><path d="M12.5 2.5l5 5-2 .8-3 3 .5 3.7-1.5 1.5-3.5-3.5-4.5 4.5-.5-.5 4.5-4.5L4 9.5l1.5-1.5 3.7.5 3-3z" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"></path></svg></button>' : '') +
          (SPOOKY
            ? '<div class="llk__versprechen"><span>Halloween-Aktion</span><span>·</span><span>Versand gratis ab ' + VERSAND_AB + ' €</span><span>·</span><span>Socken geschenkt</span></div>'
            : HALLOWEEN
            ? '<div class="llk__versprechen"><span>Halloween-Sale</span><span>·</span><span>bis zu ' + STUFE_MAX + ' %</span><span>·</span><span>Versand gratis ab ' + VERSAND_AB + ' €</span></div>'
            : '<div class="llk__versprechen"><span>Versand gratis ab ' + VERSAND_AB + ' €</span><span>·</span><span>Socken geschenkt</span><span>·</span><span>' + (C.viertes ? 'Jedes ' + C.viertes.ab + '. Teil gratis' : 'Ab ' + TEILE_MAX + ' Teilen −' + STUFE_MAX + ' %') + '</span></div>') +
          '<button type="button" class="llk__zu" data-tun="zu" aria-label="Warenkorb schließen"><svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="M2.5 2.5l11 11M13.5 2.5l-11 11" stroke="currentColor" stroke-width="1.4" fill="none"></path></svg></button></div>' +
        (SPOOKY ? spukFeld() :
        '<div class="llk__leine-feld">' + ((LAUB || HERBST) ? laubDeko() : '') + '<div class="llk__motto">' + (HALLOWEEN ? 'Je voller die Leine, desto gespenstischer der Preis.' : 'Mehr Liebe, kleiner Preis') + '</div><div class="llk__leine">' +
          '<svg class="llk__seil" viewBox="0 0 360 30" preserveAspectRatio="none" aria-hidden="true"><path d="M14 4 Q180 22 346 4" stroke="' + SEIL + '" stroke-width="1.2" fill="none"></path><circle cx="14" cy="4" r="2.5" fill="' + SEIL + '"></circle><circle cx="346" cy="4" r="2.5" fill="' + SEIL + '"></circle></svg>' +
          '<div class="llk__plaetze"></div></div><div class="llk__leinentext"></div><div class="llk__sockenhinweis"></div></div>') +
        '<div class="llk__liste"></div>' +
        '<div class="llk__vorschlaege" hidden><div class="llk__vkopf"><div class="llk__vtitel">Noch was für die Leine</div><div class="llk__pfeile">' +
          '<button type="button" data-tun="zurueck" aria-label="Vorherige Vorschläge"><svg width="10" height="10" viewBox="0 0 12 12" aria-hidden="true"><path d="M7.5 2L3.5 6l4 4" stroke="currentColor" stroke-width="1.4" fill="none"></path></svg></button>' +
          '<button type="button" data-tun="vor" aria-label="Weitere Vorschläge"><svg width="10" height="10" viewBox="0 0 12 12" aria-hidden="true"><path d="M4.5 2l4 4-4 4" stroke="currentColor" stroke-width="1.4" fill="none"></path></svg></button>' +
          '</div></div><div class="llk__band"></div></div>' +
        '<div class="llk__fuss">' + (KLAR ? '<div class="llk__zeilen"></div>' : '') + '<div class="llk__summe"><span class="llk__summe-links"><span>Summe</span><span class="llk__gespart" hidden></span></span><span class="llk__summe-betrag"></span></div>' +
          '<div class="llk__versandhinweis" hidden></div>' +
          (SPOOKY ? '<div class="llk__spuk-tipp">' + esc(C.spooky.code) + ' an der Kasse: −' + C.spooky.prozent + ' % auf alles</div>' : '') +
          '<button type="button" class="llk__kasse" data-tun="kasse"><span>' + (KLAR ? 'Jetzt sicher zur Kasse' : 'Weiter') + '</span><span>·</span><span></span></button>' +
          '<div class="llk__liefer"><span></span><span class="llk__versand">Kostenlos</span></div><div class="llk__zahl"></div>' +
          (KLAR ? '<div class="llk__garantie">100 Tage Rückgaberecht <span>|</span> Socken gratis zu jeder Bestellung</div>' : '') + '</div>' +
      '</aside>';
    document.body.appendChild(w);
    var tpl = document.getElementById('llk-zahlarten');
    if (tpl) w.querySelector('.llk__zahl').innerHTML = tpl.innerHTML;
    el = {
      wurzel: w,
      plaetze: w.querySelector('.llk__plaetze'),
      leinentext: w.querySelector('.llk__leinentext'),
      sockenhinweis: w.querySelector('.llk__sockenhinweis'),
      liste: w.querySelector('.llk__liste'),
      vorschlaege: w.querySelector('.llk__vorschlaege'),
      vtitel: w.querySelector('.llk__vtitel'),
      band: w.querySelector('.llk__band'),
      summe: w.querySelector('.llk__summe-betrag'),
      gespart: w.querySelector('.llk__gespart'),
      kasse: w.querySelector('.llk__kasse'),
      kasseBetrag: w.querySelector('.llk__kasse span:nth-child(3)'),
      liefer: w.querySelector('.llk__liefer span:first-child'),
      versand: w.querySelector('.llk__versand'),
      versandhinweis: w.querySelector('.llk__versandhinweis'),
      stufen: null,
      stufentext: null,
      zeilen: w.querySelector('.llk__zeilen')
    };
    var stil = document.createElement('style');
    stil.textContent = '.llk-sr{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}';
    w.appendChild(stil);

    w.addEventListener('click', function (e) {
      var t = e.target.closest('[data-tun]');
      if (!t) return;
      var was = t.getAttribute('data-tun');
      var gz = t.closest('[data-gruppe]');
      var g = gz ? gruppen[Number(gz.getAttribute('data-gruppe'))] : null;
      if (was === 'zu') { nadel(false); schliessen(); }
      else if (was === 'nadel') nadel(!angepinnt);
      else if (was === 'kasse') zurKasseGehen();
      else if (was === 'vor') el.band.scrollBy({ left: 278, behavior: 'smooth' });
      else if (was === 'zurueck') el.band.scrollBy({ left: -278, behavior: 'smooth' });
      else if (was === 'dazu') dazu(Number(t.getAttribute('data-variante')), t);
      else if (g && was === 'plus') aendern([{ id: g.zeilen[0].key, quantity: g.zeilen[0].quantity + 1 }]);
      else if (g && was === 'minus') { var l = g.zeilen[g.zeilen.length - 1]; aendern([{ id: l.key, quantity: l.quantity - 1 }]); }
      else if (g && was === 'weg') aendern(g.zeilen.map(function (z) { return { id: z.key, quantity: 0 }; }));
    });
    /*
      Marian 2026-10-23: am Handy brauchte „Weiter“ oft zwei Tipper. iOS gibt
      den ersten Tipp nicht immer als click weiter (Hover-Nachbildung, Tipp
      direkt nach dem Scrollen). Darum zusätzlich der Finger selbst: pointerup
      auf dem Knopf, ohne Wischen, geht sofort zur Kasse; der danach eventuell
      noch kommende click ist dann schon abgefangen (zurKasse).
    */
    var tipp = null;
    el.kasse.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') tipp = { x: e.clientX, y: e.clientY }; });
    el.kasse.addEventListener('pointerup', function (e) {
      if (!tipp || e.pointerType === 'mouse') return;
      var dx = e.clientX - tipp.x, dy = e.clientY - tipp.y; tipp = null;
      if (dx * dx + dy * dy < 144) zurKasseGehen();
    });
    el.kasse.addEventListener('pointercancel', function () { tipp = null; });
    w.addEventListener('change', function (e) {
      var t = e.target;
      var was = t.getAttribute('data-tun');
      if (was === 'socke') {
        var zeile = t.closest('[data-key]');
        var eig = { _ll_geschenk: '1' };
        if (zeile.getAttribute('data-paar')) eig._ll_paar = zeile.getAttribute('data-paar');
        if (t.value !== t.getAttribute('data-auto')) eig._sockengroesse = t.value;
        aendern({ id: zeile.getAttribute('data-key'), quantity: 1, properties: eig });
      } else if (was === 'groesse') {
        wahl[t.closest('[data-produkt]').getAttribute('data-produkt')] = t.value;
        zeichneVorschlaege();
      }
    });
    document.addEventListener('keydown', function (e) { if (offen && e.key === 'Escape') schliessen(); });
  }

  /* Einmal zur Kasse: Knopf sofort sperren und „Einen Moment …“ zeigen, kein zweiter Absprung, kein Freischalten durch einen späteren Zeichnen-Lauf. */
  var zurKasse = false;
  function zurKasseGehen() {
    if (zurKasse || !korb || korb.item_count === 0) return;
    zurKasse = true;
    el.kasse.disabled = true;
    el.kasse.setAttribute('data-wartet', '');
    el.kasse.firstChild.textContent = 'Einen Moment …';
    window.location.href = root + 'checkout';
    /* Kommt die Kundin zurück (Zurück-Taste, Seite aus dem Cache), soll der Knopf wieder gehen. */
    window.addEventListener('pageshow', function () {
      zurKasse = false;
      el.kasse.removeAttribute('data-wartet');
      /* Gleicher Text wie beim ersten Zeichnen (Marian 2026-11-04: nach „Zurück“ stand dort „Weiter“). */
      el.kasse.firstChild.textContent = KLAR ? 'Jetzt sicher zur Kasse' : 'Weiter';
      if (korb) zeichnen();
    }, { once: true });
  }
  /*
    Stand-Prüfung (Marian 2026-10-31: „jeder, der die Seite offen hatte, sieht noch den alten Warenkorb“). Ein offener Tab
    behält das Skript, mit dem er geladen wurde. Beim Öffnen des Korbs und beim Zurückkehren in den Tab fragt der Korb
    darum bei Shopify den aktuellen Stand ab (Abschnitt ll-korb-stand, schreibt _ll-korb-hochladen.ts bei jedem Upload
    mit). Ist er anders oder ist eine Aktion abgelaufen, lädt die Seite einmal neu; war der Korb offen, geht er danach
    wieder auf. Je Stand höchstens ein Neuladen, damit nie eine Schleife entsteht.
  */
  var letztePruefung = 0;
  function sitzung(k, v) {
    try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) {}
    return null;
  }
  function neuLaden(stand, mitKorb) {
    if (sitzung('llk-neu-fuer') === stand) return;
    sitzung('llk-neu-fuer', stand);
    if (mitKorb) sitzung('llk-wieder-auf', '1');
    location.reload();
  }
  function standPruefen(mitKorb) {
    if (SPOOKY && Date.now() >= Date.parse(C.spooky.bis)) { neuLaden('ende-' + C.spooky.bis, mitKorb); return; }
    if (!C.stand || Date.now() - letztePruefung < 60000) return;
    letztePruefung = Date.now();
    fetch(root + '?sections=ll-korb-stand', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var m = j && /llk-stand:([^;<\s]+);/.exec(j['ll-korb-stand'] || '');
        if (m && m[1] !== C.stand) neuLaden(m[1], mitKorb || offen);
      })
      .catch(function () {});
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) { letztePruefung = 0; standPruefen(false); } });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') standPruefen(false); });

  /* Anpinnen wie bei Snocks (Marian 2026-11-03): die Tasche bleibt am Desktop rechts stehen, die Seite rückt zur Seite und
     bleibt bedienbar; gilt für die Sitzung, auch beim Seitenwechsel. Am Handy gibt es keine Nadel. */
  var angepinnt = false;
  function breit() { return !!(window.matchMedia && window.matchMedia('(min-width: 1000px)').matches); }
  function nadel(an) {
    angepinnt = !!an && KLAR && breit();
    if (el.wurzel) {
      el.wurzel.toggleAttribute('data-angepinnt', angepinnt);
      var b = el.wurzel.querySelector('.llk__nadel');
      if (b) b.setAttribute('aria-pressed', String(angepinnt));
    }
    document.documentElement.classList.toggle('llk-angepinnt', angepinnt);
    if (angepinnt) document.documentElement.style.overflow = '';
    sitzung('llk-nadel', angepinnt ? '1' : null);
  }
  function oeffnen() {
    standPruefen(true);
    if (!el.wurzel) bauen();
    if (!offen) {
      offen = true;
      el.wurzel.setAttribute('data-offen', '');
      if (!angepinnt) document.documentElement.style.overflow = 'hidden';
      setTimeout(function () { var k = el.wurzel.querySelector('.llk__korb'); if (k) k.focus({ preventScroll: true }); }, 50);
    }
    return laden(false);
  }
  function schliessen() {
    if (!offen) return;
    offen = false;
    el.wurzel.removeAttribute('data-offen');
    document.documentElement.style.overflow = '';
  }

  /* ---------- Anschluss ans Theme ---------- */
  // Nach jedem Hinzufügen aufklappen (Prestige meldet `variant:add`).
  /* Die Produktseite darf das automatische Öffnen kurz aussetzen, um zuerst ein Angebot zu zeigen (ll-kaufkasten.js,
     Marian 2026-11-03); sie öffnet den Korb danach selbst. Ein Klick aufs Korb-Symbol öffnet immer. */
  function pausiert() { return !!window.LLKorbPause && Date.now() < window.LLKorbPause; }
  document.addEventListener('variant:add', function () { if (!pausiert()) oeffnen(); });

  // Hinzufügen aus fremden Skripten (Bundles, Schnellkauf) ebenfalls erkennen.
  var altFetch = window.fetch;
  window.fetch = function (eingabe, init) {
    var url = typeof eingabe === 'string' ? eingabe : (eingabe && eingabe.url) || '';
    var vonUns = init && init.headers && init.headers['X-LL-Korb'];
    var p = altFetch.apply(this, arguments);
    if (!vonUns && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
      p.then(function (r) { if (r.ok) { persStand = {}; setTimeout(function () { if (!pausiert()) oeffnen(); }, 60); } }).catch(function () {});
    }
    return p;
  };

  // Warenkorb-Symbol öffnet die Schublade statt der Warenkorbseite.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || e.metaKey || e.ctrlKey) return;
    var pfad;
    try { pfad = new URL(a.href, location.href).pathname; } catch (x) { return; }
    if (!/\/cart\/?$/.test(pfad) || /\/cart\/?$/.test(location.pathname)) return;
    e.preventDefault();
    oeffnen();
  }, true);

  // Änderungen anderer (Aufpreis-Abgleich, Theme) nachziehen, wenn offen.
  document.addEventListener('cart:change', function (e) {
    if (e.detail && e.detail.baseEvent === 'll:korb') return;
    if (offen) setTimeout(function () { laden(false); }, 80);
  });

  // Socke auch ohne Öffnen stimmig halten (etwa nach Kauf über die Produktseite).
  function start() {
    bauen();
    if (KLAR && sitzung('llk-nadel') === '1' && breit()) { nadel(true); oeffnen(); return; }
    /* Nach dem Neuladen durch die Stand-Prüfung den Korb wieder öffnen, wenn er vorher offen war. */
    if (sitzung('llk-wieder-auf')) { sitzung('llk-wieder-auf', null); oeffnen(); }
    else laden(false).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  /*
   * Personalisierung im Schnellkauf („Optionen auswählen“): Prestige fügt nur
   * das HTML des Bausteins ein, Skripte und Stil der App-Erweiterung fehlen auf
   * Kategorieseiten. Taucht ein <ll-personalisierung> auf, das noch nicht
   * bekannt ist, die Dateien von apps.littleloved.de nachladen (Kopie der
   * Erweiterungs-Assets, apps/shop/public/pers). Danach wird das Element von
   * selbst lebendig (customElements.define).
   */
  var PERS = 'https://apps.littleloved.de/pers/';
  var persGeladen = false;
  function persNachladen() {
    // Auf Produktseiten bringt die App-Erweiterung ihre Dateien selbst mit (auch für Schnellkauf-Empfehlungen dort).
    if (/\/products\//.test(location.pathname)) return;
    if (persGeladen || !document.querySelector('ll-personalisierung') || (window.customElements && customElements.get('ll-personalisierung'))) return;
    persGeladen = true;
    var css = document.createElement('link');
    css.rel = 'stylesheet'; css.href = PERS + 'll-personalisierung.css';
    document.head.appendChild(css);
    var kauf = document.createElement('script');
    kauf.src = PERS + 'll-personalisierung-kauf.js';
    kauf.onload = kauf.onerror = function () {
      var haupt = document.createElement('script');
      haupt.src = PERS + 'll-personalisierung.js';
      document.head.appendChild(haupt);
    };
    document.head.appendChild(kauf);
  }
  /*
   * Größe/Farbe im Schnellkauf baut den Inhalt neu auf (product-rerender) und
   * ersetzt dabei das <ll-personalisierung>. Ohne Rettung wäre ein schon
   * getippter Name weg und der Kauf liefe still OHNE Namen. Darum: letzte
   * Eingabe je Produkt merken und in das neue Element zurückspielen.
   */
  var persStand = {};
  function persSchluessel(el) {
    var f = el.form || (el.closest('.quick-buy-modal__content, quick-buy-drawer, [id^="quick-buy"]') || document).querySelector('form[action*="/cart/add"]');
    return f ? f.getAttribute('id') || 'schnellkauf' : 'schnellkauf';
  }
  function persMerken(el) {
    if (!el || !el.querySelector) return;
    var mit = el.querySelector('input[name="ll-pers-wahl"][value="mit"]');
    var name = el.querySelector('.ll-pers__name');
    var pos = el.querySelector('.ll-pers__position[aria-pressed="true"]');
    persStand[persSchluessel(el)] = { mit: !!(mit && mit.checked), name: name ? name.value : '', position: pos ? pos.dataset.position : null };
  }
  function persZurueck(el) {
    var st = persStand[persSchluessel(el)];
    if (!st || !st.mit || el.__llkZurueck) return;
    el.__llkZurueck = true;
    setTimeout(function () {
      var mit = el.querySelector('input[name="ll-pers-wahl"][value="mit"]');
      if (mit && !mit.checked) { mit.checked = true; mit.dispatchEvent(new Event('change', { bubbles: true })); }
      var name = el.querySelector('.ll-pers__name');
      if (name && st.name && !name.value) { name.value = st.name; name.dispatchEvent(new Event('input', { bubbles: true })); }
      if (st.position) { var b = el.querySelector('.ll-pers__position[data-position="' + st.position + '"]'); if (b && b.getAttribute('aria-pressed') !== 'true') b.click(); }
    }, 60);
  }
  ['input', 'change', 'click'].forEach(function (typ) {
    document.addEventListener(typ, function (e) {
      var el = e.target && e.target.closest && e.target.closest('ll-personalisierung');
      if (el) setTimeout(function () { persMerken(el); }, 0);
    }, true);
  });
  // Nach dem Kauf vergessen, sonst käme der Name beim nächsten Schnellkauf wieder.
  document.addEventListener('variant:add', function () { persStand = {}; });

  if (window.MutationObserver) {
    new MutationObserver(function (liste) {
      if (!persGeladen) persNachladen();
      if (/\/products\//.test(location.pathname)) return;
      liste.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          var els = n.matches && n.matches('ll-personalisierung') ? [n] : n.querySelectorAll ? n.querySelectorAll('ll-personalisierung') : [];
          for (var i = 0; i < els.length; i++) persZurueck(els[i]);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  persNachladen();

  window.LLKorbOeffnen = oeffnen;
})();
